export default __webpack_public_path__ + "static/media/women.56475b4f.jpeg";